import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Iterable, List } from "immutable"
import ImPropTypes from "react-immutable-proptypes"
import toString from "lodash/toString"


export default class OperationSummary extends PureComponent {

  static propTypes = {
    specPath: ImPropTypes.list.isRequired,
    operationProps: PropTypes.instanceOf(Iterable).isRequired,
    toggleShown: PropTypes.func.isRequired,
    getComponent: PropTypes.func.isRequired,
    getConfigs: PropTypes.func.isRequired,
    authActions: PropTypes.object,
    authSelectors: PropTypes.object,
    extensions: PropTypes.object,
  }

  static defaultProps = {
    operationProps: null,
    specPath: List(),
    summary: ""
  }

  render() {

    let {
      toggleShown,
      getComponent,
      authActions,
      authSelectors,
      operationProps,
      specPath,
      introduced,
      visibilityOptions,
      holOntapVersion,
    } = this.props

    let {
      summary,
      isAuthorized,
      method,
      op,
      showSummary,
      operationId,
      allowTryItOut,
      originalOperationId,
      displayOperationId,
    } = operationProps.toJS()

    let {
      summary: resolvedSummary,
    } = op

    let security = operationProps.get("security")

    const AuthorizeOperationBtn = getComponent("authorizeOperationBtn")
    const OperationSummaryMethod = getComponent("OperationSummaryMethod")
    const OperationSummaryPath = getComponent("OperationSummaryPath")
    const JumpToPath = getComponent("JumpToPath", true)

    return (

      <div className={`opblock-summary opblock-summary-${method}`} onClick={toggleShown} >
        <OperationSummaryMethod method={method} />
        <OperationSummaryPath getComponent={getComponent} operationProps={operationProps} specPath={specPath} />

        {!showSummary ? null :
          <div className="opblock-summary-description">
            {toString(resolvedSummary || summary)}
          </div>
        }

        {
// ifdef NETAPP
          <div className="op-tag-container">
            {getVisibilityBadge (visibilityOptions)}
            {getIntroducedBadge (introduced, holOntapVersion)}
          </div>
// endif NETAPP
        }

        {displayOperationId && (originalOperationId || operationId) ? <span className="opblock-summary-operation-id">{originalOperationId || operationId}</span> : null}

        {
          (!allowTryItOut || !security || !security.count()) ? null :
            <AuthorizeOperationBtn
              isAuthorized={isAuthorized}
              onClick={() => {
                const applicableDefinitions = authSelectors.definitionsForRequirements(security)
                authActions.showDefinitions(applicableDefinitions)
              }}
            />
        }
        <JumpToPath path={specPath} />{/* TODO: use wrapComponents here, swagger-ui doesn't care about jumpToPath */}
      </div>
    )

  }
}

// ifdef NETAPP
function getVisibilityBadge (visibilityOptions) {
  if (visibilityOptions == undefined) {
    return null;
  }
  let visibilityType = visibilityOptions.get ('type').toUpperCase ();
  let stylingClass = '';
  if (visibilityType == 'PRIVATE') {
    stylingClass = "privateVisibilityBadgeOp";
  } else if (visibilityType == 'CONDITIONAL') {
    stylingClass= "conditionalVisibilityBadgeOp";
  }
  let introduced_dark = visibilityOptions.get('introduced_dark');
  return (
    <span className="visibility-badge"><span className={stylingClass} title={(typeof introduced_dark !== "undefined") ? `Introduced as ${visibilityType} in ${introduced_dark}` : ""}><b>{visibilityType}</b></span>&emsp;</span>
  );
}

function getIntroducedBadge (introduced, holOntapVersion) {
  if (introduced == undefined) {
    return <span className="introduced-in"></span>;
  }
  return introduced == holOntapVersion
    ? <span className="introduced-in"><b>{`New in ${introduced}`}</b></span>
    : <span className="introduced-in">{`Introduced in ${introduced}`}</span>;
}
// endif NETAPP
